import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/imgs/home_banner_pc.png'
import _imports_1 from '../assets/imgs/home_banner_mobile.png'


const _hoisted_1 = { id: "home" }
const _hoisted_2 = { id: "banner" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "banner" }
const _hoisted_5 = {
  class: "title",
  "data-aos": "fade-up"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "btn_cta" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "hide-mobile banner__bg"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "hide-md banner__bg"
}, null, -1)
const _hoisted_10 = { id: "developer" }
const _hoisted_11 = { class: "developer" }
const _hoisted_12 = {
  class: "developer__subtitle",
  "data-aos": "fade-up"
}
const _hoisted_13 = {
  class: "developer__title",
  "data-aos": "fade-up"
}
const _hoisted_14 = { class: "developer__service" }
const _hoisted_15 = { class: "developer__service--group" }
const _hoisted_16 = { class: "developer__footer" }
const _hoisted_17 = { id: "agent" }
const _hoisted_18 = { class: "agent" }
const _hoisted_19 = {
  class: "agent__subtitle",
  "data-aos": "fade-up"
}
const _hoisted_20 = {
  class: "agent__title_highlight",
  "data-aos": "fade-up"
}
const _hoisted_21 = {
  class: "agent__title",
  "data-aos": "fade-up",
  "data-aos-anchor-placement": "top-bottom"
}
const _hoisted_22 = { class: "agent__cards" }
const _hoisted_23 = { class: "agent__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_TrustedBy = _resolveComponent("TrustedBy")!
  const _component_SalesValue = _resolveComponent("SalesValue")!
  const _component_Card = _resolveComponent("Card")!
  const _component_CardMini = _resolveComponent("CardMini")!
  const _component_SelectForSignup = _resolveComponent("SelectForSignup")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", {
              class: "title__highlight",
              innerHTML: _ctx.text.home.banner.titlehighlight
            }, null, 8, ["innerHTML"]),
            _hoisted_6,
            _createVNode("span", {
              innerHTML: _ctx.text.home.banner.title
            }, null, 8, ["innerHTML"])
          ]),
          _createVNode("div", {
            class: "detail",
            innerHTML: _ctx.text.home.banner.detail
          }, null, 8, ["innerHTML"]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Button, {
              text: _ctx.text.home.banner.btnDevelper,
              class: "btn_cta__left",
              to: "/signup?signup=developer"
            }, null, 8, ["text"]),
            _createVNode(_component_Button, {
              text: _ctx.text.home.banner.btnAgent,
              btnType: "secondary",
              to: "/signup?signup=agent"
            }, null, 8, ["text"])
          ]),
          _createVNode(_component_TrustedBy, {
            title: _ctx.text.trustedBy,
            imgSize: "60",
            border: true
          }, null, 8, ["title"])
        ]),
        _hoisted_8
      ]),
      _hoisted_9
    ]),
    _createVNode(_component_SalesValue, { hideIconOnMobile: "" }),
    _createVNode("section", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.text.home.developer.madeForDev), 1),
        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.text.home.developer.title), 1),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_Card, {
              title: _ctx.text.home.developer.co_broking,
              detail: _ctx.text.home.developer.co_broking_detail,
              icon: "co-broking",
              color: "#E4EEFF",
              iconColor: "#3F7DF4",
              iconScale: true,
              learnmore: "/requestdemo"
            }, null, 8, ["title", "detail"]),
            _createVNode(_component_Card, {
              title: _ctx.text.home.developer.marketing,
              detail: _ctx.text.home.developer.marketing_detail,
              icon: "marketing",
              color: "#FFE4EC",
              iconColor: "#E27070",
              iconScale: true,
              learnmore: "/requestdemo"
            }, null, 8, ["title", "detail"]),
            _createVNode(_component_Card, {
              title: _ctx.text.home.developer.sales_management,
              detail: _ctx.text.home.developer.sales_management_detail,
              icon: "sales-management",
              color: "#EBE4FF",
              iconColor: "#8460EA",
              iconScale: true,
              learnmore: "/requestdemo"
            }, null, 8, ["title", "detail"])
          ]),
          _createVNode(_component_SalesValue, { class: "hide-mobile" })
        ]),
        _createVNode(_component_Button, {
          text: _ctx.text.request_demo,
          class: "developer__footer--btn_cta hide-md",
          to: "/requestdemo"
        }, null, 8, ["text"]),
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_Button, {
            text: _ctx.text.request_demo,
            class: "developer__footer--btn_cta hide-mobile",
            to: "/requestdemo"
          }, null, 8, ["text"]),
          _createVNode("div", null, [
            _createVNode(_component_TrustedBy, {
              title: _ctx.text.trustedByDev,
              imgSize: "60",
              color: "#fff"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.text.home.agent.madeForAgent), 1),
        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.text.home.agent.title_highlight), 1),
        _createVNode("div", _hoisted_21, _toDisplayString(_ctx.text.home.agent.title), 1),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_CardMini, {
            title: _ctx.text.home.agent.stock_title,
            detail: _ctx.text.home.agent.stock_detail,
            icon: "building",
            color: "#E4EEFF",
            iconColor: "#3F7DF4",
            mobileOutline: ""
          }, null, 8, ["title", "detail"]),
          _createVNode(_component_CardMini, {
            title: _ctx.text.home.agent.commission_title,
            detail: _ctx.text.home.agent.commission_detail,
            icon: "commission",
            color: "#CCF0F3",
            iconColor: "#21A0AB",
            mobileOutline: ""
          }, null, 8, ["title", "detail"]),
          _createVNode(_component_CardMini, {
            title: _ctx.text.home.agent.marketing_title,
            detail: _ctx.text.home.agent.marketing_detail,
            icon: "marketing",
            color: "#FFE4EC",
            iconColor: "#E27070",
            mobileOutline: ""
          }, null, 8, ["title", "detail"]),
          _createVNode(_component_CardMini, {
            title: _ctx.text.home.agent.crm_title,
            detail: _ctx.text.home.agent.crm_detail,
            icon: "sales-management",
            color: "#EBE4FF",
            iconColor: "#8460EA",
            mobileOutline: ""
          }, null, 8, ["title", "detail"])
        ]),
        _createVNode("div", _hoisted_23, [
          _createVNode(_component_Button, {
            text: _ctx.text.signup_for_free,
            class: "agent__footer--btn_cta",
            to: "/signup?signup=agent"
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _createVNode(_component_SelectForSignup, {
      title: _ctx.text.join_with_us
    }, null, 8, ["title"])
  ]))
}